import { CloseOutlined } from "@ant-design/icons";
import SaleEditModal from "./sale-edit-modal";
import { isMobile } from "@/extensions/design";

const Sale = ({ onClose, id }) => {
  const onCancel = () => onClose();

  return !isMobile ? (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" style={{width: 800}} onMouseDown={e => e.stopPropagation()}>
          <div className="client-modal-title">
            <span>Продажа #{id}</span>
            <CloseOutlined className="sport-section-title-close" onClick={onCancel} style={{ zIndex: 9 }}/>
          </div>
          <div className="custom-tabs-container">
            <SaleEditModal onClose={onClose} id={id}/>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="sport-modal">
      <div className="sport-modal-overlay">
        <div className="sport-modal-content">
          <div className="sport-modal-title">
            <span>Продажа #{id}</span>
            <CloseOutlined onClick={() => onClose(false)} className="sport-section-title-close client-close-outlined-button-style"/>
          </div>
          <SaleEditModal onClose={onClose} id={id}/>
        </div>
      </div>
    </div>
  );
};

  export default Sale;
